import * as THREE from "three";

export interface NormalizeResult {
  scale: number;
  offset: THREE.Vector3;
}

/**
 * Normalizes imported assets by centering X/Z and grounding the bounding box
 * on the floor plane. Asset scale is intentionally not altered.
 */
export function normalizeGlb(
  scene: THREE.Object3D
): NormalizeResult {
  const box = new THREE.Box3().setFromObject(scene);
  if (box.isEmpty()) {
    return { scale: 1, offset: new THREE.Vector3(0, 0, 0) };
  }

  const center = new THREE.Vector3();
  box.getCenter(center);

  const offsetY = -box.min.y;
  const offset = new THREE.Vector3(
    -center.x,
    offsetY,
    -center.z
  );

  return { scale: 1, offset };
}
